"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonIcon = void 0;
var React = require("react");
var ButtonIcon_style_1 = require("./ButtonIcon.style");
var Button_1 = require("../Button");
var Icon_1 = require("../../Icon/Icon");
var helpers_1 = require("../../../helpers");
exports.ButtonIcon = function (props) {
    var icon = props.icon, value = props.value;
    return (React.createElement(Button_1.default, __assign({}, props, { style: { padding: '0px', marginBottom: '6px' } }),
        React.createElement(ButtonIcon_style_1.default.Wrap, null,
            React.createElement(ButtonIcon_style_1.default.Text, null, props.children ? props.children : 'Button'),
            React.createElement(ButtonIcon_style_1.default.IconWrap, { style: { border: "1px solid " + props.colorPrimary } },
                ' ',
                React.createElement(Icon_1.default, { icon: icon, size: value ? 22 : 38 }),
                value ? React.createElement("span", null, helpers_1.prettifyIfNumber(value)) : null))));
};
exports.default = exports.ButtonIcon;
//# sourceMappingURL=ButtonIcon.js.map